module.exports = __webpack_public_path__ + "img/item5.3b42563b.png";